import { useState } from 'react'
import { getLanguage } from '../../../lib/i18n.js'

const COMMON = ['BG', 'TB', 'LB', 'CD', 'BS', 'PC']
const labels = {
  ka: { account: 'ანგარიში', choose: 'აირჩიეთ ანგარიში', add: 'სხვა ანგარიშის დამატება', details: 'ანგარიშის დეტალები', holder: 'ანგარიშის მფლობელი', bank: 'ბანკი', iban: 'IBAN', swift: 'SWIFT', save: 'შენახვა და არჩევა', manual: 'ხელით შეყვანა', none: 'მიმღებს შენახული ანგარიში არ აქვს', other: 'სხვა ბანკი', bad: 'შეამოწმეთ IBAN და ანგარიშის მონაცემები.',
    not_allowed: 'ეს პირი ამ ხელშეკრულებაში თანხის მიმღები ვერ იქნება — აირჩიეთ მესაკუთრე ან უფლებამოსილი აგენტი.',
    colleague: 'შეგიძლიათ შეინახოთ მხოლოდ საკუთარი ან მესაკუთრის ანგარიში — კოლეგის ანგარიშს ის თავად ინახავს.',
    no_context: 'ანგარიშის შესანახად ხელშეკრულება გახსენით ქონებიდან ან შეხვედრიდან.',
    network: 'სერვერთან კავშირი ვერ დამყარდა — შეამოწმეთ ინტერნეტი და სცადეთ ხელახლა.' },
  en: { account: 'Account', choose: 'Choose account', add: 'Add another account', details: 'Account details', holder: 'Account holder', bank: 'Bank', iban: 'IBAN', swift: 'SWIFT', save: 'Save and select', manual: 'Enter manually', none: 'No saved account for this recipient', other: 'Other bank', bad: 'Check the IBAN and account details.',
    not_allowed: 'This person cannot receive money under this contract — choose the owner or an authorised agent.',
    colleague: 'You can save only your own receiving account or the owner’s — a colleague saves their own.',
    no_context: 'Open the contract from a property or a meeting to save an account.',
    network: 'Could not reach the server — check the connection and try again.' },
  ru: { account: 'Счёт', choose: 'Выберите счёт', add: 'Добавить счёт', details: 'Реквизиты счёта', holder: 'Владелец счёта', bank: 'Банк', iban: 'IBAN', swift: 'SWIFT', save: 'Сохранить и выбрать', manual: 'Ввести вручную', none: 'У получателя нет сохранённого счёта', other: 'Другой банк', bad: 'Проверьте IBAN и данные счёта.',
    not_allowed: 'Этот человек не может получать деньги по этому договору — выберите собственника или уполномоченного агента.',
    colleague: 'Можно сохранить только свой счёт или счёт собственника — коллега сохраняет свой сам.',
    no_context: 'Чтобы сохранить счёт, откройте договор из объекта или встречи.',
    network: 'Не удалось связаться с сервером — проверьте соединение и повторите.' },
}
const compact = v => String(v || '').replace(/\s+/g, '').toUpperCase()
export function geIbanValid(value) {
  const iban = compact(value)
  if (!/^GE\d{2}[A-Z]{2}[A-Z0-9]{16}$/.test(iban)) return false
  let mod = 0
  for (const c of iban.slice(4) + iban.slice(0, 4)) {
    const digits = /[A-Z]/.test(c) ? String(c.charCodeAt(0) - 55) : c
    for (const d of digits) mod = (mod * 10 + Number(d)) % 97
  }
  return mod === 1
}
const fields = stage => stage === 'initial'
  ? { iban: 'payment_account', bank: 'payment_bank', holder: 'payment_account_holder', swift: 'initial_payment_swift' }
  : { iban: 'owner_payment_iban', bank: 'owner_payment_bank', holder: 'owner_payment_account_holder', swift: 'owner_payment_swift' }

export function PaymentAccountPicker({ draft, values, stage, partyId, partyName, recipientType, selectedId, onSelect, onSaved }) {
  const lang = ['ka', 'en', 'ru'].includes(getLanguage()) ? getLanguage() : 'ka'
  const l = labels[lang]
  const f = fields(stage)
  const approvedAgent = stage === 'initial' && recipientType === 'authorised_agent'
  const accounts = (draft?.payment_accounts || []).filter(a => a.party_id === partyId && (!approvedAgent || a.verified_at))
  const banks = [...(draft?.payment_banks || [])].sort((a, b) => {
    const x = COMMON.indexOf(a.iban_code), y = COMMON.indexOf(b.iban_code)
    return (x < 0 ? 100 : x) - (y < 0 ? 100 : y) || String(a.name_ka).localeCompare(String(b.name_ka))
  })
  const matching = accounts.find(a => a.id === selectedId)
  const [manual, setManual] = useState(false)
  const [details, setDetails] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [otherBank, setOtherBank] = useState(false)
  const chosenBank = (geIbanValid(values[f.iban]) ? banks.find(b => b.iban_code === compact(values[f.iban]).slice(4, 6)) : null)
    || banks.find(b => b.name_ka === values[f.bank] || b.name_en === values[f.bank])
  const choose = a => onSelect(stage, { [f.iban]: a.iban, [f.bank]: a.bank_name, [f.holder]: a.account_holder, [f.swift]: a.swift }, a.id)
  const edit = patch => onSelect(stage, patch, null)
  const bankChanged = code => {
    const b = banks.find(x => x.iban_code === code)
    setOtherBank(code === 'other')
    edit(b ? { [f.bank]: b.name_ka, [f.swift]: b.swift } : { [f.bank]: '', [f.swift]: '' })
  }
  const ibanChanged = value => {
    const iban = compact(value)
    const bank = geIbanValid(iban) ? banks.find(b => b.iban_code === iban.slice(4, 6)) : null
    edit(bank ? { [f.iban]: iban, [f.bank]: bank.name_ka, [f.swift]: bank.swift } : { [f.iban]: iban })
  }
  const save = async () => {
    // 🔴 A PROPERTY-FIRST DRAFT HAS NO MEETING (2026-09-21). `meeting.id` is null there (1185:
    // core_contract.js answers `meeting: { id: null, status: 'property_context', property_id }`),
    // so this guard returned before doing anything: no request, no error, no state change — a
    // button that did nothing, six clicks in a row, with the network silent. Measured live.
    // ⚠️ Both the wrapper and the server already handled this case; only the guard did not.
    //    db/core.js: `propertyId && !meetingId ? \`property/${propertyId}\` : \`meeting/${meetingId}\``
    //    and POST /api/core/property/:id/payment-account exists for exactly this flow.
    // ⚠️ It also made the AUTHORISED-AGENT route unusable property-first: the server demands
    //    account_selection.initial (approved_agent_payment_account_required), which can only come
    //    from a saved account, which could not be saved.
    if (!partyId || !(draft?.meeting?.id || draft?.meeting?.property_id)) return
    if (compact(values[f.iban]).startsWith('GE') && (!geIbanValid(values[f.iban]) || !chosenBank)) { setError(l.bad); return }
    setSaving(true); setError('')
    try {
      const { savePaymentAccount } = await import('../../../db/core.js')
      const r = await savePaymentAccount(draft.meeting.id, { party_id: partyId, account_holder: values[f.holder], iban: values[f.iban], bank_name: values[f.bank], swift: values[f.swift], currency: values.rent?.currency }, draft.meeting.property_id)
      onSaved(r.account, stage)
      setManual(false)
    } catch (e) {
      // 🗣️ SAY WHICH REFUSAL IT WAS (2026-09-21). Every failure used to collapse into `l.bad` —
      // "check the IBAN" — including the server refusing the RECIPIENT, which no IBAN edit can fix.
      // Before the property-first guard was fixed above, no save reached the server there, so
      // nobody met these; now agents will, and a sentence that points at the wrong field teaches
      // them to retype a correct number. The codes are core_contract.js's own for this route.
      const code = e?.message || e?.code || ''
      setError(code === 'payment_recipient_not_allowed' ? l.not_allowed
        : code === 'cannot_save_colleague_receiving_account' ? l.colleague
        : code === 'property_context_required' ? l.no_context
        : /failed to fetch|networkerror|load failed/i.test(code) ? l.network
        : l.bad)
    }
    finally { setSaving(false) }
  }
  return <div className="w-full space-y-1.5" data-payment-account-stage={stage}>
    {approvedAgent && !accounts.length && <div className="text-xs text-[#8A4B2A]">{lang === 'ka'
      ? 'უფლებამოსილი აგენტის დადასტურებული ანგარიში ჯერ არ არის. მიმართეთ ადმინისტრატორს.'
      : 'No approved receiving account for this agent yet. Ask an administrator.'}</div>}
    {!manual && partyId && <select className="w-full rounded border border-[#B9B6AD] bg-white px-2 py-2 text-sm" value={matching?.id || ''}
      onChange={e => { const a = accounts.find(x => x.id === e.target.value); if (a) choose(a); else if (!approvedAgent) setManual(true) }}>
      <option value="">{accounts.length ? l.choose : l.none}</option>
      {accounts.map(a => <option value={a.id} key={a.id}>{a.bank_name} · ••••{compact(a.iban).slice(-4)}{a.verified_at ? ' ✓' : ''}</option>)}
    </select>}
    {!manual && !partyId && <span className="text-xs text-[#666]">{l.manual}</span>}
    {!manual && !approvedAgent && <button type="button" className="text-xs underline text-[#1F6F4F]" onClick={() => {
      setManual(true); setDetails(true)
      if (!values[f.holder] && partyName) edit({ [f.holder]: partyName })
    }}>{l.add}</button>}
    {!approvedAgent && (manual || !partyId) && <div className="space-y-2 rounded border border-[#B9B6AD] p-2" data-payment-account-manual>
      <label className="block text-xs">{l.bank}
        <select className="mt-1 w-full rounded border border-[#B9B6AD] bg-white px-2 py-2" value={otherBank ? 'other' : chosenBank?.iban_code || ''} onChange={e => bankChanged(e.target.value)}>
          <option value="">—</option>{banks.map(b => <option key={b.iban_code} value={b.iban_code}>{lang === 'en' ? b.name_en : b.name_ka}</option>)}<option value="other">{l.other}</option>
        </select>
      </label>
      {otherBank && <input className="w-full rounded border border-[#B9B6AD] px-2 py-2" aria-label={l.bank} value={values[f.bank] || ''} onChange={e => edit({ [f.bank]: e.target.value })} />}
      <label className="block text-xs">{l.iban}<input className="mt-1 w-full rounded border border-[#B9B6AD] px-2 py-2" inputMode="text" autoCapitalize="characters" value={values[f.iban] || ''} onChange={e => ibanChanged(e.target.value)} /></label>
      <details><summary className="cursor-pointer text-xs text-[#1F6F4F]">{l.details}</summary>
        <label className="block text-xs mt-2">{l.holder}<input className="mt-1 w-full rounded border border-[#B9B6AD] px-2 py-2" value={values[f.holder] || ''} onChange={e => edit({ [f.holder]: e.target.value })} placeholder={partyName || ''} /></label>
        <label className="block text-xs mt-2">{l.swift}<input className="mt-1 w-full rounded border border-[#B9B6AD] px-2 py-2" value={values[f.swift] || ''} onChange={e => edit({ [f.swift]: e.target.value.toUpperCase() })} readOnly={!!chosenBank} /></label>
      </details>
      {partyId && <button type="button" disabled={saving} className="text-xs rounded bg-[#1F6F4F] text-white px-3 py-1.5" onClick={save}>{l.save}</button>}
      {error && <div className="text-xs text-[#8A4B2A]">{error}</div>}
    </div>}
    {!manual && matching && <details open={details} onToggle={e => setDetails(e.currentTarget.open)}>
      <summary className="cursor-pointer text-xs text-[#1F6F4F]">{l.details}</summary>
      <div className="text-xs break-all">{matching.account_holder} · {matching.bank_name} · {matching.iban} · {matching.swift}</div>
    </details>}
  </div>
}
